/*
 * Lib Module Displays
 */

Lib.Display = (function() {
    var self = {};

    $(Lib).on('document.ready', function() {
        self.matchHeight();
    });

    $(Lib).on('orientation.change', function() {
        $.fn.matchHeight._update();
    });

    self.matchHeight = function() {

        let appliedGroups = [];
        $('div[data-match-height]').each(function() {

            let group = $(this).data('match-height');

            if ($.inArray(group, appliedGroups) === -1) {

                appliedGroups.push(group);

                let options = $(this).data('match-height-options') || {selector: false};

                if (!options.selector) {
                    options.selector = '[data-match-height="' + group + '"]';
                }

                let targetElements = $(options.selector);
                targetElements.matchHeight(options);
            }

        });
    };

    return self;

})();
